export const NAME = 'feePayment';

const SET_FEE_PAYMENT_FILTERS = `SET_FEE_PAYMENT_FILTERS_${NAME}`;

export const setFeePaymentFilters = (filters) => ({
	type: SET_FEE_PAYMENT_FILTERS,
	payload: filters,
});

export const filterDefault = {
	searchText: '',
	campusId: null,
	curriculumProgramId: null,
	gradeIds: [],
	sectionIds: [],
};

const ACTION_MAP = {
	[SET_FEE_PAYMENT_FILTERS]: (state, action) => ({
		...state,
		filters: {
			...filterDefault,
			...state.filters,
			...action.payload,
		},
	}),
};

const initialState = {
	filters: filterDefault,
};

export const reducer = (state = initialState, action) => {
	const actionFunc = ACTION_MAP[action.type];
	return actionFunc ? actionFunc(state, action) : state;
};
